// crewbit-admin/src/lib/scheduleTravelBuffer.ts
//
// Schedule Module Phase C C1.6 — 5-tier travel-buffer-minutes resolver per spec §0.5.
// Body byte-equivalent to mobile crewbit-mobile/lib/scheduleTravelBuffer.ts modulo
// import paths (per feedback_admin_pair_must_match_mobile_body.md parity rule).
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §0.5 + §0.13.

export interface ResolveTravelBufferInput {
  urlParamRaw?: string | null;
  userPref?: number | null;
  businessOverride?: number | null;
  industryDefault?: number | null;
}

const HARD_FALLBACK_MINUTES = 15;
const MIN_VALID = 1;
const MAX_VALID = 120;

function isValidBuffer(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value >= MIN_VALID && value <= MAX_VALID;
}

export function resolveTravelBuffer(input: ResolveTravelBufferInput): number {
  const urlNum = input.urlParamRaw ? parseInt(input.urlParamRaw, 10) : NaN;
  if (isValidBuffer(urlNum)) return urlNum;
  if (isValidBuffer(input.userPref)) return input.userPref;
  if (isValidBuffer(input.businessOverride)) return input.businessOverride;
  if (isValidBuffer(input.industryDefault)) return input.industryDefault;
  return HARD_FALLBACK_MINUTES;
}
